import axios from 'axios';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { appInsights } from '../auth/appInsight';

const useFetch = (url, { method = 'GET', body = null, skip = false, refreshKey = 0 } = {}) => {
  const [loading, setLoading] = useState(!skip);
  const [error, setError] = useState(false);
  const [errorDescription, setErrorDescription] = useState('');
  const [data, setData] = useState([]);
  const {
    user: { accessToken }
  } = useSelector((state) => state.user);

  const fetchData = async (signal, overrideBody) => {
    setLoading(true);
    setError(false);
    const requestBody = overrideBody !== undefined ? overrideBody : body;
    const isPost = method.toUpperCase() === 'POST';
    try {
      await axios[isPost ? 'post' : 'get'](
        url,
        ...(isPost ? [requestBody, { headers: { Authorization: 'Bearer ' + accessToken }, signal }] : [{ headers: { Authorization: 'Bearer ' + accessToken }, signal }])
      )
        .then((res) => {
          setData(res?.data);
        })
        .catch((error) => {
          appInsights.trackException({ error: new Error('url' + url + error) });
          setError(true);
          setErrorDescription(error);
        })
        .finally(() => setLoading(false));
    } catch (err) {
      if (err.name === 'AbortError') {
        console.log('Fetch aborted');
      } else {
        console.error('Fetch error:', err);
      }
    }
  };

  useEffect(() => {
    if (skip || !url) {
      setLoading(false);
      return;
    }
    const controller = new AbortController();
    fetchData(controller.signal);
    return () => {
      controller.abort();
    };
  }, [url, skip, refreshKey]);

  try {
    return { loading, error, setError, data, fetchData, errorDescription };
  } catch (error) {
    appInsights.trackException({ error: new Error('fetch url' + url + error) });
  }
};

export default useFetch;
